var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-page-controls bg-white" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "wf-page-controls-items" }, [
        _c(
          "div",
          {
            staticClass:
              "wf-page-control-item wf-page-control-item-navigation-back"
          },
          [
            _c("div", { staticClass: "page-navigation-back-button" }, [
              _vm.backUrl
                ? _c(
                    "button",
                    {
                      staticClass: "d-inline-flex btn btn-sm btn-light",
                      attrs: {
                        type: "button",
                        onclick: "history.back()",
                        "aria-label": "Back"
                      }
                    },
                    [
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--k-carrot-back-title d-inline d-lg-none"
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--k-arrow-left-sm d-none d-lg-inline"
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-lg-inline pl-1" }, [
                        _vm._v(
                          "\n              Return back to previous page\n            "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "wf-page-control-item wf-page-control-item-share-button" },
      [
        _c("div", { staticClass: "dropdown" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-light",
              attrs: {
                type: "button",
                id: "share-page-dropdown-button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }
            },
            [
              _c("span", { staticClass: "mr-1" }, [_vm._v("Share")]),
              _vm._v(" "),
              _c("span", {
                staticClass: "png-icon png-icon-icons-glyph--k-share "
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-menu",
              attrs: { "aria-labelledby": "share-page-dropdown-button" }
            },
            [
              _c(
                "div",
                { staticClass: "a2a_kit a2a_kit_size_40 a2a_default_style" },
                [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "list-unstyled d-flex flex-column align-items-center m-0"
                    },
                    [
                      _c("li", { staticClass: "p-1" }, [
                        _c("a", { staticClass: "a2a_button_twitter" })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "p-1" }, [
                        _c("a", { staticClass: "a2a_button_facebook" })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "p-1" }, [
                        _c("a", { staticClass: "a2a_button_linkedin" })
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "p-1" }, [
                        _c("a", { staticClass: "a2a_button_pinterest" })
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }